import { IntegrationCategories } from "src/components/template/constants";
import type { Template, TemplateDashboard } from "src/components/template/types";

export const getIsDashboardNotIntegrated = (
    dashboard: TemplateDashboard | undefined,
    isIntegrated: {
        gitlab: boolean;
        gitlabSelfManaged: boolean;
        github: boolean;
        jira: boolean;
        notion: boolean;
        slack: boolean;
        google: boolean;
        microsoft: boolean;
    }
) => {
    if (!dashboard) return false;
    const dependencies =
        dashboard.templates &&
        dashboard.templates.reduce((acc, template) => [...acc, ...template.dependencies], []);

    if (!dashboard || !dependencies || dependencies.length === 0) return false;

    let notIntegrated = true;
    if (dependencies.includes(IntegrationCategories.git)) {
        notIntegrated =
            notIntegrated &&
            !isIntegrated.github &&
            !isIntegrated.gitlab &&
            !isIntegrated.gitlabSelfManaged;
    }

    if (dependencies.includes(IntegrationCategories.pm)) {
        notIntegrated = notIntegrated && !isIntegrated.jira && !isIntegrated.notion;
    }

    if (dependencies.includes(IntegrationCategories.collaboration)) {
        notIntegrated =
            notIntegrated && !isIntegrated.slack && !isIntegrated.google && !isIntegrated.microsoft;
    }

    if (dependencies.includes(IntegrationCategories.meetings)) {
        notIntegrated = notIntegrated && !isIntegrated.google && !isIntegrated.microsoft;
    }

    if (dependencies.includes(IntegrationCategories.slack)) {
        notIntegrated = notIntegrated && !isIntegrated.slack;
    }

    if (dependencies.includes(IntegrationCategories.wellbeing)) {
        notIntegrated =
            notIntegrated &&
            !isIntegrated.github &&
            !isIntegrated.gitlab &&
            !isIntegrated.gitlabSelfManaged &&
            !isIntegrated.jira &&
            !isIntegrated.notion;
    }
    return notIntegrated;
};

export const getIsTemplateNotIntegrated = (
    template: Template,
    isIntegrated: {
        gitlab: boolean;
        gitlabSelfManaged: boolean;
        github: boolean;
        jira: boolean;
        notion: boolean;
        slack: boolean;
        google: boolean;
        microsoft: boolean;
    }
): IntegrationCategories[] => {
    if (!template) return [];

    const dependencies: IntegrationCategories[] = template?.dependencies;

    if (!dependencies || dependencies.length === 0) return [];

    const notIntegrated: IntegrationCategories[] = [];
    if (dependencies.includes(IntegrationCategories.git)) {
        if (!isIntegrated.github && !isIntegrated.gitlab && !isIntegrated.gitlabSelfManaged) {
            notIntegrated.push(IntegrationCategories.git);
        }
    }

    if (dependencies.includes(IntegrationCategories.pm)) {
        if (!isIntegrated.jira && !isIntegrated.notion) {
            notIntegrated.push(IntegrationCategories.pm);
        }
    }

    if (dependencies.includes(IntegrationCategories.collaboration)) {
        if (!isIntegrated.slack && !isIntegrated.google && !isIntegrated.microsoft) {
            notIntegrated.push(IntegrationCategories.collaboration);
        }
    }

    if (dependencies.includes(IntegrationCategories.meetings)) {
        if (!isIntegrated.google && !isIntegrated.microsoft) {
            notIntegrated.push(IntegrationCategories.meetings);
        }
    }

    if (dependencies.includes(IntegrationCategories.slack)) {
        if (!isIntegrated.slack) {
            notIntegrated.push(IntegrationCategories.slack);
        }
    }

    if (
        dependencies.includes(IntegrationCategories.wellbeing) ||
        dependencies.includes(IntegrationCategories.fragmentation)
    ) {
        if (
            !isIntegrated.github &&
            !isIntegrated.gitlab &&
            !isIntegrated.gitlabSelfManaged &&
            !isIntegrated.jira &&
            !isIntegrated.notion
        ) {
            notIntegrated.push(IntegrationCategories.wellbeing);
        }
    }
    return notIntegrated;
};

export const getIsTemplateItemNotIntegrated = (
    dependencies: IntegrationCategories[],
    isIntegrated: {
        gitlab: boolean;
        gitlabSelfManaged: boolean;
        github: boolean;
        jira: boolean;
        notion: boolean;
        slack: boolean;
        google: boolean;
        microsoft: boolean;
    }
): IntegrationCategories[] => {
    if (!dependencies || dependencies.length === 0) return [];

    const notIntegrated: IntegrationCategories[] = [];
    if (dependencies.includes(IntegrationCategories.git)) {
        if (!isIntegrated.github && !isIntegrated.gitlab && !isIntegrated.gitlabSelfManaged) {
            notIntegrated.push(IntegrationCategories.git);
        }
    }

    if (dependencies.includes(IntegrationCategories.pm)) {
        if (!isIntegrated.jira && !isIntegrated.notion) {
            notIntegrated.push(IntegrationCategories.pm);
        }
    }

    if (dependencies.includes(IntegrationCategories.collaboration)) {
        if (!isIntegrated.slack && !isIntegrated.google && !isIntegrated.microsoft) {
            notIntegrated.push(IntegrationCategories.collaboration);
        }
    }

    if (dependencies.includes(IntegrationCategories.meetings)) {
        if (!isIntegrated.google && !isIntegrated.microsoft) {
            notIntegrated.push(IntegrationCategories.meetings);
        }
    }

    if (dependencies.includes(IntegrationCategories.slack)) {
        if (!isIntegrated.slack) {
            notIntegrated.push(IntegrationCategories.slack);
        }
    }

    if (
        dependencies.includes(IntegrationCategories.wellbeing) ||
        dependencies.includes(IntegrationCategories.fragmentation)
    ) {
        if (
            !isIntegrated.github &&
            !isIntegrated.gitlab &&
            !isIntegrated.gitlabSelfManaged &&
            !isIntegrated.jira &&
            !isIntegrated.notion
        ) {
            notIntegrated.push(IntegrationCategories.wellbeing);
        }
    }
    return notIntegrated;
};
